export const PLATFORM = 'TWINIT'; //selected platform to apply the settings 

export const SETTINGS = {
    TWINIT: {
        REACT_APP_BASE_URL: '/ipaplugins',
        REACT_APP_PRIMARY_COLOUR: '#f8d7da',
        REACT_APP_SECONDARY_COLOUR: '#f5c6cb',
        REACT_APP_LINK_COLOUR: '#7AACF8',
        REACT_APP_SECONDARY_FONT_COLOUR: 'black',
        REACT_APP_LOGO_URL: '/logo_twinit.svg',
        REACT_APP_MANIFEST_IGNORE: 'Navisworks'
    }
}
